import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_DATA_SEARCH_STAFF } from './constant/emptyData';

const initialState = {
    search: {
        ...EMPTY_DATA_SEARCH_STAFF
    }
};

export const staffSlice = createSlice({
    name: 'staff',
    initialState,
    reducers: {
        searchStaff: (state, action) => {
            state.search = action.payload;
        },
        searchStaffPageFirst: (state, action) => {
            state.search.page = 1;
        },
    },
});

const { reducer, actions } = staffSlice;
export const { searchStaff, searchStaffPageFirst } = actions;
export const selectSearchStaff = (state) => state?.features?.staff?.search;
export default reducer;
